/* PURE-AIR Maker Theme JS */
(function () {
  "use strict";

  /* --- Sticky header shrink + announcement hide on scroll --- */
  var header = document.getElementById("SiteHeader");
  var stickyTop = document.getElementById("StickyTop");
  var lastKnown = 0, ticking = false, prevY = 0;

  /* Auto-hide the sticky block while scrolling down, restore it on scroll up.

     Why: .sticky-top is 108px tall on a 375px screen and sits at z-index 200, so
     it permanently covers whatever is at the top of the viewport. Measured on the
     footer, "About Us", "Contact / Request a Quote" and "Payment Options" were
     unclickable once the user scrolled to the bottom of the page — elementFromPoint
     returned the header, not the link. scroll-padding-top fixes browser-driven
     anchor landings but cannot help plain scrolling, and shrinking the block from
     170px to 108px only narrowed the dead zone.

     Hiding on scroll-down also gives phones back 108px of reading area, and the
     usual objection (nav becomes unreachable) does not apply because any upward
     scroll brings it straight back. */
  var HIDE_AFTER = 240;   /* keep it pinned near the top of the page */
  var DELTA_MIN  = 6;     /* ignore sub-pixel jitter and rubber-banding */
  function onScroll() {
    lastKnown = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(function () {
        var scrolled = lastKnown > 80;
        if (header) header.classList.toggle("is-scrolled", scrolled);
        if (stickyTop) {
          var delta = lastKnown - prevY;
          if (Math.abs(delta) >= DELTA_MIN) {
            if (delta > 0 && lastKnown > HIDE_AFTER) {
              stickyTop.classList.add("is-hidden");
            } else if (delta < 0) {
              stickyTop.classList.remove("is-hidden");
            }
            prevY = lastKnown;
          }
          /* Never leave it hidden at the very top of the document. */
          if (lastKnown <= HIDE_AFTER) stickyTop.classList.remove("is-hidden");
        }
        ticking = false;
      });
      ticking = true;
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* --- Mobile menu toggle --- */
  var toggle = document.getElementById("MenuToggle");
  var mobileNav = document.getElementById("MobileNav");
  if (toggle && mobileNav) {
    toggle.addEventListener("click", function () {
      var open = mobileNav.classList.toggle("open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* --- Product gallery: handled by product.liquid carousel script --- */

  /* --- Filters page: machine chip selection --- */
  var chips = document.querySelectorAll("[data-machine-chip]");
  if (chips.length) {
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        var target = chip.getAttribute("data-machine-chip");
        chips.forEach(function (c) { c.classList.toggle("active", c === chip); });
        document.querySelectorAll("[data-fitment-panel]").forEach(function (panel) {
          var match = panel.getAttribute("data-fitment-panel") === target;
          panel.classList.toggle("active", match);
          panel.hidden = !match;
        });
      });
    });
    /* activate first chip by default */
    chips[0].click();
  }

  /* --- Cart count refresh (Shopify AJAX API) --- */
  function bumpCartBadge() {
    var el = document.getElementById("CartCount");
    var link = el ? el.closest(".cart-link") : document.querySelector(".cart-link");
    [el, link].forEach(function (node) {
      if (!node) return;
      node.classList.remove("is-bump");
      /* force reflow so the animation can replay on repeated adds */
      void node.offsetWidth;
      node.classList.add("is-bump");
      setTimeout(function () { node.classList.remove("is-bump"); }, 520);
    });
  }

  function refreshCartCount(opts) {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById("CartCount");
        if (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? "flex" : "none";
        }
        if (opts && opts.bump) bumpCartBadge();
        return cart;
      })
      .catch(function () { return null; });
  }

  /* Fill the toast checkout button with the live cart subtotal so shoppers see
     what they are about to pay before leaving the page. */
  function paintCheckoutTotals(toast, cart) {
    if (!toast || !cart) return;
    var amtEl = toast.querySelector(".pa-toast-checkout-amt");
    var countEl = toast.querySelector(".pa-toast-cart-count");
    var priced = typeof cart.items_subtotal_price === "number" && cart.items_subtotal_price > 0;
    if (amtEl) {
      if (priced) {
        amtEl.textContent = money(cart.items_subtotal_price);
        amtEl.hidden = false;
      } else {
        amtEl.hidden = true;
      }
    }
    if (countEl && typeof cart.item_count === "number") {
      countEl.textContent = cart.item_count + (cart.item_count === 1 ? " item" : " items") + (priced ? " in cart" : " in cart \u00b7 pricing on request");
      countEl.hidden = false;
    }
  }
  document.addEventListener("cart:updated", function (e) {
    refreshCartCount({ bump: !!(e && e.detail && e.detail.bump) });
  });

  /* --- Toast notifications --- */
  function toastWrap() {
    var wrap = document.getElementById("PaToastWrap");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "pa-toast-wrap";
      wrap.id = "PaToastWrap";
      wrap.setAttribute("role", "status");
      wrap.setAttribute("aria-live", "polite");
      document.body.appendChild(wrap);
    }
    return wrap;
  }

  function showToast(opts) {
    var wrap = toastWrap();
    var t = document.createElement("div");
    t.className = "pa-toast";

    var visual = "";
    if (opts.image) {
      visual = '<img class="pa-toast-thumb" src="' + opts.image + '" alt="">';
    } else {
      visual = '<span class="pa-toast-icon" aria-hidden="true">\u2713</span>';
    }

    var actions = "";
    if (opts.actions !== false) {
      actions =
        '<div class="pa-toast-actions">' +
        '<button class="pa-toast-continue" type="button">Continue shopping</button>' +
        '<a class="pa-toast-checkout" href="/checkout">' +
        '<span class="pa-toast-checkout-label">Checkout now</span>' +
        '<span class="pa-toast-checkout-amt" hidden></span>' +
        "</a>" +
        "</div>" +
        '<div class="pa-toast-foot">' +
        '<span class="pa-toast-cart-count" hidden></span>' +
        '<a class="pa-toast-cartlink" href="/cart">View cart</a>' +
        "</div>";
    }

    t.innerHTML =
      visual +
      '<div class="pa-toast-body">' +
      '<div class="pa-toast-title">' + (opts.title || "Added to cart") + "</div>" +
      (opts.sub ? '<div class="pa-toast-sub">' + opts.sub + "</div>" : "") +
      actions +
      "</div>" +
      '<button class="pa-toast-close" type="button" aria-label="Dismiss">\u00d7</button>';

    wrap.appendChild(t);
    requestAnimationFrame(function () { t.classList.add("show"); });

    var timer = setTimeout(dismiss, opts.duration || 5200);
    function dismiss() {
      clearTimeout(timer);
      t.classList.remove("show");
      t.classList.add("hide");
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 240);
    }
    t.querySelector(".pa-toast-close").addEventListener("click", dismiss);
    var contBtn = t.querySelector(".pa-toast-continue");
    if (contBtn) contBtn.addEventListener("click", dismiss);
    t.addEventListener("mouseenter", function () { clearTimeout(timer); });
    t.addEventListener("mouseleave", function () { timer = setTimeout(dismiss, 2200); });

    /* Show the live cart subtotal on the checkout button. When the caller
       already has a cart payload we paint immediately; otherwise fetch it. */
    if (opts.actions !== false) {
      if (opts.cart) {
        paintCheckoutTotals(t, opts.cart);
      } else {
        fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { paintCheckoutTotals(t, cart); })
          .catch(function () { /* leave the plain label in place */ });
      }
    }
    return t;
  }
  window.PaToast = showToast;

  function escapeHtml(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  function money(cents) {
    if (typeof cents !== "number") return "";
    return "$" + (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* --- AJAX add-to-cart for any /cart/add form (keeps user on the page) --- */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = (form.getAttribute("action") || "").split("?")[0];
    if (action !== "/cart/add" || form.hasAttribute("data-no-ajax")) return;

    e.preventDefault();
    var btn = form.querySelector('button[type="submit"], input[type="submit"]');
    var originalLabel = btn ? btn.innerHTML : null;
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = "Adding\u2026";
    }

    var fd = new FormData(form);
    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: fd,
      credentials: "same-origin"
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) {
          showToast({
            title: "Couldn't add to cart",
            sub: escapeHtml((res.data && (res.data.description || res.data.message)) || "Please try again."),
            actions: false,
            duration: 5000
          });
          return;
        }
        var item = res.data || {};
        var qty = item.quantity || parseInt(fd.get("quantity"), 10) || 1;
        var title = item.product_title || item.title || "Item";
        var img = item.image || (item.featured_image && item.featured_image.url) || null;
        var lineTotal = typeof item.line_price === "number" && item.line_price > 0 ? money(item.line_price) : "";
        var toast = showToast({
          title: "Added to cart",
          sub: escapeHtml(title) + " \u00b7 Qty " + qty + (lineTotal ? " \u00b7 " + lineTotal : ""),
          image: img ? img : null
        });
        return refreshCartCount({ bump: true }).then(function (cart) {
          paintCheckoutTotals(toast, cart);
          return cart;
        });
      })
      .catch(function () {
        /* network failure — fall back to the classic full-page POST */
        form.setAttribute("data-no-ajax", "1");
        form.submit();
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          if (originalLabel !== null) btn.innerHTML = originalLabel;
        }
      });
  });

  /* --- Contact form: prefill subject from ?subject= query --- */
  var params = new URLSearchParams(window.location.search);
  var subject = params.get("subject");
  if (subject) {
    var subjInput = document.querySelector('input[name="contact[subject]"], input[data-subject-field]');
    if (subjInput && !subjInput.value) subjInput.value = subject;
    var bodyArea = document.querySelector('textarea[name="contact[body]"]');
    if (bodyArea && !bodyArea.value) {
      bodyArea.value = "Hi, I would like to request a quote for: " + subject + "\n\nQuantity needed:\nShipping ZIP code:\n";
    }
  }

  /* --- Filter cost calculator --- */
  var calcForm = document.getElementById("FilterCalc");
  if (calcForm) {
    var run = function () {
      var hours = parseFloat(document.getElementById("CalcHours").value) || 0;
      var material = document.getElementById("CalcMaterial").value;
      /* filter life in hours by material intensity */
      var life = { light: 400, medium: 250, heavy: 150 }[material] || 250;
      var setsPerYear = Math.max(1, Math.ceil((hours * 52) / life));
      var out = document.getElementById("CalcResult");
      if (out) {
        var discount = setsPerYear >= 2 ? " (5% bulk discount applies when you order 2+ sets together)" : "";
        out.innerHTML =
          "<b>" + setsPerYear + " filter set" + (setsPerYear > 1 ? "s" : "") + " per year</b>" +
          "<p>Based on " + hours + " hrs/week of " + material + "-intensity cutting, each PURE-AIR filter set lasts about " +
          life + " machine-hours." + discount + " Request a quote for exact pricing.</p>";
        out.style.display = "block";
      }
    };
    calcForm.addEventListener("input", run);
    run();
  }

  /* ---------- Quote reply-time estimate (contact / industries pages) ----------
     The product page runs its own copy with extra wiring; here we only fill the
     shared success-panel placeholders so the promise stays consistent sitewide.
     Support hours: Mon-Fri 09:00-18:00 America/New_York. */
  function paQuoteEta() {
    var now = new Date();
    var wd = "", hh = 0;
    try {
      new Intl.DateTimeFormat("en-US", {
        timeZone: "America/New_York", weekday: "short", hour: "numeric", hour12: false
      }).formatToParts(now).forEach(function (p) {
        if (p.type === "weekday") wd = p.value;
        if (p.type === "hour") hh = parseInt(p.value, 10);
      });
    } catch (err) {
      return { main: "within 1 business day", sub: "Our team replies Mon-Fri, 9 AM-6 PM ET." };
    }
    var dayIdx = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[wd];
    if (dayIdx >= 1 && dayIdx <= 5 && hh >= 9 && hh < 18) {
      return {
        main: "today, within about 4 working hours",
        sub: "Our US-hours team is online right now (Mon-Fri, 9 AM-6 PM ET)."
      };
    }
    var addDays = 1;
    if (dayIdx === 5 && hh >= 18) addDays = 3;
    else if (dayIdx === 6) addDays = 2;
    else if (dayIdx === 0) addDays = 1;
    else if (hh < 9) addDays = 0;
    var next = new Date(now.getTime() + addDays * 86400000);
    var label = new Intl.DateTimeFormat(undefined, { weekday: "long", month: "short", day: "numeric" }).format(next);
    return {
      main: (addDays === 0 ? "this morning, " : "") + "by " + label + " (US business hours)",
      sub: "Received outside office hours - our team picks it up at the start of the next business day (Mon-Fri, 9 AM-6 PM ET)."
    };
  }
  window.PaQuoteEta = paQuoteEta;

  var etaMain = document.getElementById("PdpQuoteEta");
  /* Skip on the product page, whose own script already owns these nodes. */
  if (etaMain && !document.getElementById("PdpQuoteForm")) {
    var etaVals = paQuoteEta();
    etaMain.textContent = etaVals.main;
    var etaSub = document.getElementById("PdpQuoteEtaSub");
    if (etaSub) etaSub.textContent = etaVals.sub;
    var okPanelGlobal = document.getElementById("PdpQuoteOk");
    if (okPanelGlobal) {
      setTimeout(function () {
        okPanelGlobal.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 250);
    }
  }

  /* ---------- Quote ledger mirror ----------
     Shopify's native contact form only emails the store owner - there is no
     submission list in the admin. This mirrors each submission to our own
     ledger so every lead is tracked with a status and follow-up notes.

     Deliberately additive and best-effort:
     - We do NOT preventDefault. The native POST proceeds exactly as before, so
       Shopify's notification email and the success panel are never at risk.
     - The mirror is sent with `keepalive` so it survives the page unload that
       the native submit triggers milliseconds later.
     - Any failure is swallowed. A broken ledger must never look like a broken
       form to the customer.

     Opt in per template by tagging the form: `data-pa-mirror="shopify-contact"`. */
  var PA_INGEST_URL = "https://pureairshop-udeznho6.manus.space/api/quote-ingest";

  /* contact[foo] -> foo, so the payload keys match the ingest contract. */
  function paFieldKey(name) {
    var match = /^contact\[([a-z_]+)\]$/.exec(name || "");
    return match ? match[1] : null;
  }

  function paMirrorForm(form) {
    var source = form.getAttribute("data-pa-mirror");
    if (!source) return;
    /* A Fit Guide photo upload is asynchronous. Never create a ledger row until
       every selected image URL is available in the hidden form fields. */
    if (form.getAttribute("data-pa-uploading") === "true") return;

    var payload = { source: source, page_url: window.location.href };
    var fields = form.querySelectorAll("input[name], textarea[name], select[name]");
    Array.prototype.forEach.call(fields, function (el) {
      var key = paFieldKey(el.getAttribute("name"));
      if (!key) return;
      if ((el.type === "checkbox" || el.type === "radio") && !el.checked) return;
      var value = (el.value || "").trim();
      if (value) payload[key] = value;
    });

    if (!payload.email) return;

    try {
      window.fetch(PA_INGEST_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        mode: "cors",
        keepalive: true,
      })["catch"](function () {});
    } catch (err) {
      /* Older browsers without fetch/keepalive: skip silently. */
    }
  }

  var mirrorForms = document.querySelectorAll("form[data-pa-mirror]");
  Array.prototype.forEach.call(mirrorForms, function (form) {
    form.addEventListener("submit", function () {
      paMirrorForm(form);
    });
  });
})();
